import { render, staticRenderFns } from "./horizons-signup.vue?vue&type=template&id=225612c8&scoped=true&"
import script from "./horizons-signup.vue?vue&type=script&lang=js&"
export * from "./horizons-signup.vue?vue&type=script&lang=js&"
import style0 from "./horizons-signup.vue?vue&type=style&index=0&id=225612c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225612c8",
  null
  
)

export default component.exports